export default __webpack_public_path__ + "static/11-63077f73a8c96696733c3abcd701db2d.webp";